import React from 'react';
import { SportType } from '@/types';

interface SportEmojiProps {
  sportType: string;
  className?: string;
  size?: 'small' | 'medium' | 'large' | 'xl';
}

const SportEmoji: React.FC<SportEmojiProps> = ({ sportType, className = "", size = 'medium' }) => {
  const sizeClasses = {
    small: 'h-6 w-6',
    medium: 'h-8 w-8',
    large: 'h-10 w-10',
    xl: 'h-12 w-12'
  };

  const commonProps = {
    className: `inline-block shrink-0 ${sizeClasses[size]} ${className}`,
    viewBox: '0 0 48 48',
    role: 'img' as const,
    'aria-label': `${sportType} icon`,
    focusable: false,
  };

  switch (sportType.toLowerCase()) {
    case 'nba':
      return (
        <svg {...commonProps}>
          <circle cx="24" cy="24" r="20" fill="#f97316" stroke="#7c2d12" strokeWidth="2" />
          <path d="M5 22.5h38M24 4c-7 8-7 32 0 40M24 4c7 8 7 32 0 40M8 12c9 6 23 6 32 0M8 36c9-6 23-6 32 0" fill="none" stroke="#7c2d12" strokeWidth="2" />
        </svg>
      );
    case 'soccer':
      return (
        <svg {...commonProps}>
          <circle cx="24" cy="24" r="20" fill="#f8fafc" stroke="#334155" strokeWidth="2" />
          <path d="m24 15 7 5-3 8h-8l-3-8 7-5Z" fill="#0f172a" />
          <path d="m24 15-1-9M31 20l9-3M28 28l5 9M20 28l-5 9M17 20l-9-3" fill="none" stroke="#334155" strokeWidth="2" />
          <path d="m23 6-7 4-8 7-2 8 3 9 6 3 9 7 9-7 6-3 3-9-2-8-8-7-9-4Z" fill="none" stroke="#64748b" strokeWidth="1.5" />
        </svg>
      );
    case 'nfl':
      return (
        <svg {...commonProps}>
          <path d="M7 31C4 22 12 11 24 7c11-4 18-1 17 8-1 10-11 20-23 24-7 2-10 0-11-8Z" fill="#92400e" stroke="#451a03" strokeWidth="2" />
          <path d="m14 34 21-22M19 22l10 5M21 19l2 10M25 17l2 10M29 14l2 10" fill="none" stroke="#f8fafc" strokeLinecap="round" strokeWidth="2" />
        </svg>
      );
    case 'mlb':
      return (
        <svg {...commonProps}>
          <circle cx="24" cy="24" r="20" fill="#f8fafc" stroke="#cbd5e1" strokeWidth="2" />
          <path d="M12 10c9 8 8 20-1 28M36 10c-9 8-8 20 1 28" fill="none" stroke="#dc2626" strokeWidth="2" />
          <path d="m14 14-4 1m6 4-4 2m5 4-4 3m21-14 4 1m-6 4 4 2m-5 4 4 3" fill="none" stroke="#dc2626" strokeLinecap="round" strokeWidth="1.5" />
        </svg>
      );
    case 'nhl':
      return (
        <svg {...commonProps}>
          <path d="M13 7h6l9 25c1 3 4 4 8 4h6v5h-8c-7 0-10-3-12-8L13 7Z" fill="#94a3b8" stroke="#334155" strokeWidth="2" strokeLinejoin="round" />
          <ellipse cx="13" cy="38" rx="9" ry="4" fill="#0f172a" stroke="#64748b" strokeWidth="2" />
        </svg>
      );
    default:
      return null;
  }
};

export default SportEmoji;
